var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[(_vm.$store.state.loading)?_c('Loader'):_vm._e(),_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }